import React from 'react';

const Option = ({value}) => <option value={value}>{value}</option>;

export default Option;



// WEBPACK FOOTER //
// ./src/components/Dropdown/Option.js